import { createSlice } from '@reduxjs/toolkit';

export const defaultState = {
  previewedFeature: {
    subFeatureIndex: undefined,
    featureIndex: undefined
  },
};

const featuresSlice = createSlice({
  initialState: defaultState,
  name: 'features',
  reducers: {
    setPreviewedFeature: (state, { payload }) => {
      const { subFeatureIndex, featureIndex } = payload;
      state.previewedFeature = {
        subFeatureIndex,
        featureIndex
      };
    }
  }
});

export const {
  setPreviewedFeature
} = featuresSlice.actions;

export default featuresSlice.reducer;